export { SECTIONS } from "@/data/siteContent";

export const COLOR_HEX = {
  magenta: "#FF00DD",
  orange: "#FF8C00",
  yellow: "#FFD400",
  lime: "#C6F000",
  purple: "#7B1FFF",
};
